export default "__VITE_ASSET__BREXqgg6__"